const variantSelector = document.querySelector(
  "variant-selection.variant-selection"
);
if (variantSelector) {
  variantSelector.addEventListener("variant-change", (data) => {
    if (data) {
        const variant = data.detail.variant;
        if (variant.id) {
          const exVatCents = Math.round(variant.price / 1.2);
          const format = Shopify?.exvat_money_format || "£{{amount}}";
          const exVatPrice = window.Shopify.formatMoney(exVatCents, format);
          const exVatElement = document.querySelector(
            ".product-price-info__excluding-vat span.money--ex-vat.no-vat.excluding-vat"
          );
          if (exVatElement) {
            exVatElement.innerHTML = exVatPrice;
          }
        }
    }
  });
}
